"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var analyticsEventName_1 = __importDefault(require("./analyticsEventName"));
var track_1 = __importDefault(require("./track"));
var trackSocialAuthLoginClick = function (network) {
    (0, track_1.default)(analyticsEventName_1.default.SIGNED_IN, {
        type: network.toLowerCase(),
    });
};
var initTrackSocialAuthLoginClick = function () {
    var loginLinks = document.querySelectorAll('.social-auth');
    loginLinks.forEach(function (loginLink) {
        var _a;
        if (typeof ((_a = loginLink.dataset) === null || _a === void 0 ? void 0 : _a.network) === 'undefined') {
            return;
        }
        if (typeof loginLink.dataset.heapEventAdded !== 'undefined') {
            return;
        }
        // eslint-disable-next-line no-param-reassign
        loginLink.dataset.heapEventAdded = '1';
        loginLink.addEventListener('click', function () { return trackSocialAuthLoginClick(loginLink.dataset.network); });
    });
};
exports.default = initTrackSocialAuthLoginClick;
